import { useCallback, useMemo, useState } from 'react';

interface Cell {
    kpiIdx: number;
    monthIdx: number | null;
}

const useCellId = () => {
    const [cells, setCells] = useState<Cell[]>([]);

    const sortedCells = useMemo(() => {
        return cells.sort((c1, c2) => {
            if (c1.kpiIdx === c2.kpiIdx) {
                return (c1.monthIdx ?? -1) - (c2.monthIdx ?? -1);
            }

            return c1.kpiIdx - c2.kpiIdx;
        });
    }, [cells]);

    const getCellId = useCallback((kpiIdx: number, monthIdx: number | null) => {
        const cellId = sortedCells.findIndex(c => c.kpiIdx === kpiIdx && c.monthIdx === monthIdx);

        if (cellId === -1) {
            setCells(oldCells => {
                if (oldCells.find(c => c.kpiIdx === kpiIdx && c.monthIdx === monthIdx)) {
                    return oldCells;
                } else {
                    return [
                        ...oldCells,
                        { kpiIdx, monthIdx }
                    ];
                }
            });
        }

        return cellId;
    }, [sortedCells]);

    return { getCellId };
};

export default useCellId;